<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: null,
  },
  subTitle: {
    type: String,
    default: null,
  },
  description: {
    type: String,
    default: null,
  },
  variant: {
    type: String,
    default: "base",
  },
});
</script>

<template>
  <div
    v-if="title || subTitle || description"
    class="flex flex-wrap mb-4 lg:mb-6 3xl:mb-8"
  >
    <h2
      v-if="title"
      class="w-full floor-headline-section"
      :class="{ 'mb-3 lg:mb-4 3xl:mb-6': subTitle || description }"
    >
      {{ title }}
    </h2>
    <h3
      v-if="subTitle"
      class="w-full floor-label"
      :class="{ 'mb-2 lg:mb-3 3xl:mb-4': description }"
    >
      {{ subTitle }}
    </h3>
    <p
      v-if="description"
      class="w-full font-secondary text-2xs leading-4 text-interface-transparent-white px-3 lg:text-sm lg:leading-5 lg:px-6 3xl:text-base 3xl:leading-6 3xl:px-8"
    >
      {{ description }}
    </p>
  </div>
</template>
